import Chart from 'chart.js/auto'
import { CURRENCY_NAME } from './currency.js'

function getColour(index, opacity) {
    const colours = [
        `rgba(54, 162, 235, ${opacity})`,
        `rgba(255, 99, 132, ${opacity})`,
        `rgba(255, 206, 86, ${opacity})`,
        `rgba(75, 192, 192, ${opacity})`,
        `rgba(153, 102, 255, ${opacity})`,
        `rgba(255, 159, 64, ${opacity})`,
        `rgba(201, 203, 207, ${opacity})`,
        `rgba(111, 214, 155, ${opacity})`,
        `rgba(204, 102, 153, ${opacity})`,
        `rgba(95, 162, 206, ${opacity})`
    ]
    return colours[index % colours.length]
}

function convertDataIntoDataset(portfoliosData) {
    const allStocks = new Set()
    portfoliosData.forEach(portfolioData => {
        Object.keys(portfolioData.portfolio).forEach(stock => {
            allStocks.add(stock)
        })
    })
    const stocksArray = Array.from(allStocks).sort()
    return stocksArray.map((stock, index) => {
        const data = portfoliosData.map(portfolioData => {
            if (portfolioData.portfolio[stock]) {
                return portfolioData.portfolio[stock].value
            }
            return 0
        })
        return {
            label: stock,
            data,
            backgroundColour: getColour(index, 0.7),
            borderColour: getColour(index, 1),
            borderWidth: 1
        }
    })
}

function createStockInfo(portfoliosData) {
    const stocksInfo = {}
    portfoliosData.forEach(portfolioData => {
        const portfolioName = portfolioData.name
        stocksInfo[portfolioName] = {}
        Object.keys(portfolioData.portfolio).forEach(stock => {
            const shares = portfolioData.portfolio[stock]['shares held']
            const value = portfolioData.portfolio[stock]['value']
            const pricePerShare = shares ? value / shares : 0
            stocksInfo[portfolioName][stock] = {
                shares,
                value,
                pricePerShare
            }
        })
    })
    return stocksInfo
}

function getMaxSession(historyData) {
    let max = 0
    Object.values(historyData).forEach(bySession => {
        Object.keys(bySession).forEach(s => {
            const n = Number(s)
            if (n > max) max = n
        })
    })
    return max
}

function allShareholderNames(historyData) {
    return Object.keys(historyData).sort()
}

/** Latest saved snapshot for this person at or before sessionNum (carry forward). */
function lastSnapshotAtOrBefore(bySession, sessionNum) {
    if (!bySession) {
        return null
    }
    const atOrBefore = Object.keys(bySession)
        .map(s => Number(s))
        .filter(n => n <= sessionNum)
        .sort((a, b) => a - b)
    if (atOrBefore.length === 0) {
        return null
    }
    const last = atOrBefore[atOrBefore.length - 1]
    return bySession[String(last)]
}

function portfoliosAtSession(historyData, names, sessionNum) {
    return names.map(name => {
        const snap = lastSnapshotAtOrBefore(historyData[name], sessionNum)
        if (snap) {
            return snap
        }
        return { name, portfolio_value: 0, portfolio: {} }
    })
}

let portfolioHistoryChartInstance = null

function updateSessionLabel(el, sessionNum, maxSession) {
    el.textContent = `Session ${sessionNum} / ${maxSession}`
}

function renderSessionChart(sessionNum, portfoliosData, labels) {
    const ctx = document.getElementById('portfolioHistoryChart').getContext('2d')
    const datasets = convertDataIntoDataset(portfoliosData)
    const totals = portfoliosData.map(p => p.portfolio_value)
    const stocksInfo = createStockInfo(portfoliosData)

    if (portfolioHistoryChartInstance) {
        portfolioHistoryChartInstance.destroy()
    }

    portfolioHistoryChartInstance = new Chart(ctx, {
        type: 'bar',
        data: {
            labels,
            datasets
        },
        options: {
            responsive: true,
            scales: {
                x: {
                    stacked: true,
                    title: {
                        display: true,
                        text: 'Portfolios'
                    }
                },
                y: {
                    stacked: true,
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: `Value (${CURRENCY_NAME})`
                    }
                }
            },
            plugins: {
                title: {
                    display: true,
                    text: `Portfolio history — end of session ${sessionNum}`,
                    font: {
                        size: 18
                    }
                },
                tooltip: {
                    callbacks: {
                        afterTitle(context) {
                            const i = context[0].dataIndex
                            return `Total value: ${totals[i]} ${CURRENCY_NAME}`
                        },
                        label(context) {
                            const stockName = context.dataset.label
                            const i = context.dataIndex
                            const portfolioName = labels[i]
                            if (stocksInfo[portfolioName] && stocksInfo[portfolioName][stockName]) {
                                const info = stocksInfo[portfolioName][stockName]
                                return [
                                    `${stockName}: ${info.value} ${CURRENCY_NAME}`,
                                    `Price per Share: ${info.pricePerShare} ${CURRENCY_NAME}`,
                                    `Shares Held: ${info.shares}`
                                ]
                            }
                            return `${stockName}: 0 ${CURRENCY_NAME} (not in portfolio)`
                        }
                    }
                },
                legend: {
                    display: false
                }
            }
        }
    })
}

var fs = require('fs')
const historyData = JSON.parse(fs.readFileSync('portfolio_history.json', 'utf8'))

const sessionSlider = document.getElementById('portfolioHistorySession')
const sessionLabel = document.getElementById('portfolioHistorySessionLabel')

const maxSession = getMaxSession(historyData)
const names = allShareholderNames(historyData)

if (maxSession < 1 || names.length === 0) {
    sessionSlider.disabled = true
    sessionLabel.textContent = 'No data'
} else {
    sessionSlider.min = '1'
    sessionSlider.max = String(maxSession)
    sessionSlider.value = '1'

    function applySession() {
        const sessionNum = Number(sessionSlider.value)
        updateSessionLabel(sessionLabel, sessionNum, maxSession)
        const portfoliosData = portfoliosAtSession(historyData, names, sessionNum)
        renderSessionChart(sessionNum, portfoliosData, names)
    }

    sessionSlider.addEventListener('input', applySession)
    applySession()
}
